import React from 'react';

export default class MenuLink extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <a
        href={this.props.link}
        className={this.props.className}
        onClick={this.props.onClick}
        role={this.props.role}
      >
        {this.props.text}
      </a>
    );
  }
}
